'use client';

import CategoryPage from '@/joystagram-components/components/consumer/CategoryPage';

export default function CategoryPageClient({ serverCategoryData }) {
  return <CategoryPage serverCategoryData={serverCategoryData} />;
}
